import { Contact } from "../contact";
import { MemberInstrument } from "../memberInstrument";

/**
 * Member_Entity type guard.
 *
 * @param {any} memberJson Member object from API
 * @returns {boolean} Return true if type is Member_Entity
 */
function validator(memberJson: unknown): memberJson is Member_Entity {
  if (typeof memberJson === "object" && memberJson != null) {
    Member_Entity.requiredFields.forEach((element) => {
      if (!Object.keys(memberJson).includes(element))
        throw new Error("Field ${element} is null or undefined");
    });
  }
  return true;
}

export default class Member_Entity {
  static requiredFields = [
    "contacts",
    "memberInstruments",
    "tags",
    "unions",
    "newlyCreated",
  ];

  constructor(memberJson: unknown) {
    if (validator(memberJson)) {
      this.id = memberJson.id;
      this.userUUID = memberJson.userUUID;
      this.organizationID = memberJson.organizationID;
      this.avatar = memberJson.avatar;
      this.firstName = memberJson.firstName;
      this.middleName = memberJson.middleName;
      this.lastName = memberJson.lastName;
      this.nickName = memberJson.nickName;
      this.companyName = memberJson.companyName;
      this.ssn = memberJson.ssn;
      this.ein = memberJson.ein;
      this.bio = memberJson.bio;
      this.goodStanding = memberJson.goodStanding;
      this.public = memberJson.public;
      this.verified = memberJson.verified;
      this.company = memberJson.company;
      this.contactBySMS = memberJson.contactBySMS;
      this.pro = memberJson.pro;
      this.subscriber = memberJson.subscriber;
      this.subscriptionID = memberJson.subscriptionID;
      this.contacts = memberJson.contacts;
      this.memberInstruments = memberJson.memberInstruments;
      // this.tags = memberJson.tags;
      // this.unions = memberJson.unions;
      this.bazaarCustomerID = memberJson.bazaarCustomerID;
      this.email = memberJson.email;
      this.newlyCreated = memberJson.newlyCreated;
    } else {
      throw new Error(
        "Failed to create new instance of ${ Member_Entity.name }: ${e}"
      );
    }
  }

  id?: number;
  userUUID?: string;
  organizationID?: number;
  avatar?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  nickName?: string;
  companyName?: string;
  ssn?: string;
  ein?: string;
  bio?: string;
  goodStanding?: boolean;
  public?: boolean;
  verified?: boolean;
  company?: boolean;
  contactBySMS?: boolean;
  pro?: boolean;
  subscriber?: boolean;
  subscriptionID?: number;
  contacts: Array<Contact>;
  memberInstruments: Array<MemberInstrument>;
  // tags: Array<Tag>;
  // unions: Array<Union>;
  bazaarCustomerID?: number;
  email?: string;
  newlyCreated: boolean;
}
